import { ErrorMessage } from "#root/components/alert";
import { GlyphLoading } from "#root/components/glyphs";
import { InvoicePreview } from "#root/components/invoice";
import { billingInvoiceCollection } from "#root/schema/invoices";
import { useData } from "#root/utility/hooks";
import type { ReactNode } from "react";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageLayout from "./layout";

export default function AdminInvoicePreview({ invoiceId: id }): ReactNode {
  const [message, setMessage] = useState<ReactNode | null>(null);
  const navigate = useNavigate();

  const [preview] = useData(async () => {
    if (id) {
      const { row } = await billingInvoiceCollection.action(`${id}/preview`, {});
      return row;
    }
  }, [id]);

  const generateCorrespondence = useCallback(async () => {
    try {
      const { row } = await billingInvoiceCollection.action(`${id}/generateCorrespondence`, {});
      navigate("/billing/correspondence/" + row.id);
    } catch (error: any) {
      console.log(error);
      setMessage(<ErrorMessage error/>);
    }
  }, [navigate, id]);

  if (!preview) {
    return <GlyphLoading/>;
  }

  return (
    <PageLayout title="Invoice Preview">
      <section>
        <div className="button-row">
          <a className="button" onClick={generateCorrespondence}>
            Generate Email
          </a>
        </div>
        {message}
        <InvoicePreview preview={preview}/>
      </section>
    </PageLayout>
  );
}
